namespace GeniuzPOS.PosShift {
    export interface PsVatRefundRow {
        Id?: number;
        DocNo?: string;
        DocDate?: string;
        ShopId?: string;
        BookNo?: string;
        No?: string;
        IssueName?: string;
        IssueByDate?: string;
        Passport?: string;
        FristName?: string;
        LastName?: string;
        Nation?: string;
        ArriveDate?: string;
        DepartureDate?: string;
        FlightNo?: string;
        Addressno?: string;
        Street?: string;
        District?: string;
        City?: string;
        Province?: string;
        ZipCode?: string;
        Country?: string;
        Email?: string;
        Total?: number;
        Vat?: number;
        VatRateNo?: number;
        RoundedVatRefund?: number;
        PayVatAmount?: number;
        Remark?: string;
        Status?: number;
        Offline?: number;
        RefFg?: VatRefundDocFg;
        RefNo?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        DtList?: PsVatRefundDtRow[];
        ConfigPrint?: string;
    }

    export namespace PsVatRefundRow {
        export const idProperty = 'DocNo';
        export const nameProperty = 'DocNo';
        export const localTextPrefix = 'PosShift.PsVatRefund';
        export const lookupKey = 'PsVatRefundRow';

        export function getLookup(): Q.Lookup<PsVatRefundRow> {
            return Q.getLookup<PsVatRefundRow>('PsVatRefundRow');
        }
        export const deletePermission = '1POSBASE:ใบกำกับภาษี:VatRefund:Modify';
        export const insertPermission = '1POSBASE:ใบกำกับภาษี:VatRefund:Modify';
        export const readPermission = '1POSBASE:ใบกำกับภาษี:VatRefund:View';
        export const updatePermission = '1POSBASE:ใบกำกับภาษี:VatRefund:Modify';

        export declare const enum Fields {
            Id = "Id",
            DocNo = "DocNo",
            DocDate = "DocDate",
            ShopId = "ShopId",
            BookNo = "BookNo",
            No = "No",
            IssueName = "IssueName",
            IssueByDate = "IssueByDate",
            Passport = "Passport",
            FristName = "FristName",
            LastName = "LastName",
            Nation = "Nation",
            ArriveDate = "ArriveDate",
            DepartureDate = "DepartureDate",
            FlightNo = "FlightNo",
            Addressno = "Addressno",
            Street = "Street",
            District = "District",
            City = "City",
            Province = "Province",
            ZipCode = "ZipCode",
            Country = "Country",
            Email = "Email",
            Total = "Total",
            Vat = "Vat",
            VatRateNo = "VatRateNo",
            RoundedVatRefund = "RoundedVatRefund",
            PayVatAmount = "PayVatAmount",
            Remark = "Remark",
            Status = "Status",
            Offline = "Offline",
            RefFg = "RefFg",
            RefNo = "RefNo",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            DtList = "DtList",
            ConfigPrint = "ConfigPrint"
        }
    }
}
